// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React, { useEffect, useState } from 'react';
import * as microsoftTeams from "@microsoft/teams-js";
import {
  BrowserRouter as Router,
  Route,
  Switch, Redirect
} from "react-router-dom";

//MS Teams pages
import Privacy from "./Privacy";
import TermsOfUse from "./TermsOfUse";
import Tab from "./Tab";
import ConsentPopup from "./ConsentPopup";
import ClosePopup from "./ClosePopup";

//Pats pages
import Home from "./home";
//import Swiperdemo from "./home/swiperDemo";
import Rewards from "./rewards";
import Badges from "./badges";
import GenericNotFound from "./common/genericNotFound.js";
import Login from "./login";
import Profile from "./profile";
import Post from "./post";
import Feedback from "./feedback";
import EditPost from "./home/EditPost";
import Comment from "./home/comment";
// import ControlledPopup from './home/popupDemo';

//Header, Menu and global
import Menu from "./common/menu.js";
import Header from "./common/header.js";
import "./common/global.css";
import auth from "./common/auth";
import Register from "./register";
import AllNotify from "./allNotification";
import RewardForm from "./rewards/rewardform";
import RewardHistory from "./rewards/history";
import Analytics from "./analytics";
import Admin from './admin/admin';
import $ from 'jquery';
import Users from './admin/user';
import EditUser from './admin/EditUser';
import ManageRewards from './admin/ManageRewards';
import RewardRequest from './admin/rewardRequest';
import NewReward from './admin/addNewReward';
import EditReward from './admin/EditReward';
import ValuesAwards from './admin/ValuesAwards';
import AddValues from './admin/AddValues';
import EditValues from './admin/EditValues';
import Maintenance from './Maintenance.js';
/**
 * The main app which handles the initialization and routing
 * of the app.
 */
const App = () => {
  // Initialize the Microsoft Teams SDK
  //microsoftTeams.initialize();


  // Display the app home page hosted in Teams
  return (

    <Router>
      <Switch>
        <Route exact path="/privacy" component={Privacy} />
        <Route exact path="/termsofuse" component={TermsOfUse} />
        <Route exact path="/tab" component={Tab} />
        <Route exact path="/auth-start" component={ConsentPopup} />
        <Route exact path="/auth-end" component={ClosePopup} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/register" component={Register} />
        <PrivateRoute exact path="/home" component={Home} />
        <PrivateRoute exact path="/EditPost/:id" component={EditPost} />
        <PrivateRoute exact path="/analytics" component={Analytics} />
        <AdminRoute exact path="/admin" component={Admin} />
        <AdminRoute exact path="/admin/user-management" component={Users} />
        <AdminRoute exact path="/admin/user-management/edit-user/:id" component={EditUser} />
        <AdminRoute exact path="/admin/manage-rewards" component={ManageRewards} />
        <AdminRoute exact path="/admin/manage-rewards/open-requests" component={RewardRequest} />
        <AdminRoute exact path="/admin/manage-rewards/add-new-reward" component={NewReward} />
        <AdminRoute exact path="/admin/manage-rewards/edit-reward/:id" component={EditReward} />
        <AdminRoute exact path="/admin/core-values-awards" component={ValuesAwards} />
        <AdminRoute exact path="/admin/core-values-awards/add-values" component={AddValues} />
        <AdminRoute exact path="/admin/core-values-awards/edit-values/:id" component={EditValues} />
        <PrivateRoute exact path="/" component={Home} />
        <PrivateRoute exact path="/rewards/:rewardid/:brand" component={RewardForm} />
        <PrivateRoute exact path="/rewards/history" component={RewardHistory} />
        <PrivateRoute exact path="/rewards" component={Rewards} />
        <PrivateRoute exact path="/feedback" component={Feedback} />
        <PrivateRoute exact path="/badges" component={Badges} />
        <PrivateRoute exact path="/profile/:id" component={Profile} />
        <PrivateRoute exact path="/post/:id" component={Post} />
        <PrivateRoute exact path="/allNotification" component={AllNotify} />
        <Route exact path="/comment" component={Comment} />
        <Route component={GenericNotFound} />
      </Switch>
    </Router>
  )
}

const AdminRoute = ({ component: Component, ...rest }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "api/analytics/UserRole")
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful === true) {
          if (data.userrole === 'Admin' || data.userrole === 'LnD') {
            setIsAdmin(true);
          }
        } else {
          setError('Failed to fetch user role');
        }

        setIsLoading(false);
      })
      .catch((error) => {
        setError('Error fetching user role');
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    // Return loading state if data is still being fetched
    return <div>Loading...</div>;
  }

  if (error) {
    // Handle error state
    console.error(error);
    return <div>Error fetching user role</div>;
  }

  // Check if the user has the required role
  const hasRequiredRole = isAdmin;

  return (
    <Route
      {...rest}
      render={(props) =>
        hasRequiredRole ? (
          <div>
            {/* Additional components specific to the admin route */}
            <PrivateRoute component={Component} />
          </div>
        ) : (
          <Redirect to="/home" />
        )
      }
    />
  );
};

const PrivateRoute = ({ component: Component, ...rest }) => (
  // <Route
  //   {...rest}
  //   render={(props) => <PrivateLayout component={Component} />}
  // />

  <Route
    {...rest}
    render={(props) =>
      auth.isAuthenticated() ? (
        <PrivateLayout component={Component} />
      ) : (
        <Redirect
          to={{
            pathname: "/tab",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const PrivateLayout = ({ component: Component, ...rest }) => {
  const [menuToggle, setMenuToggle] = useState(false);
  const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "api/analytics/UserRole")
      .then((response) => response.json())
      .then((data) => {
        //console.log('response', data);
        if (data.status === 503) {
          setMaintenance(true);
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 503) {
          setMaintenance(true);
        }
      });
  }, []);

  return (
    <>
      {
        maintenance ? (
          <Maintenance />
        ) : (
          <div className={window.innerWidth <= 1024 ? menuToggle ? 'menu-open' : '' : ''}>
            <Header menuToggle={menuToggle} setMenuToggle={setMenuToggle} />
            <div className="hd-spacing"></div>
            <div className="main">
              <Menu menuToggle={menuToggle} setMenuToggle={setMenuToggle} />
              <div className="content-main">
                <div className="cm-container">
                  <Component />
                </div>
              </div>
            </div>
          </div>
        )}
    </>
  );
}

export default App;
